import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {CompletedBatchFiltersType} from '../../interfaces/batch'

const d = new Date()

const initialCompletedBatchFilter: CompletedBatchFiltersType = {
  searchTerm: '',
  startDate: d.toString(),
  endDate: d.toString(),
  page: 1,
  timestamp: '',
}

const completedBatchFilterSlice = createSlice({
  name: 'completedBatchFilter',
  initialState: initialCompletedBatchFilter,
  reducers: {
    setCompletedBatchFilter: (state, action: PayloadAction<CompletedBatchFiltersType>) => {
      state.searchTerm = action.payload.searchTerm
      state.startDate = action.payload.startDate
      state.endDate = action.payload.endDate
      state.page = action.payload.page
      state.timestamp = action.payload.timestamp
    },
    resetCompletedBatchFilter: (state) => {
      return {
        ...initialCompletedBatchFilter,
        timestamp: new Date().getTime().toString(),
      }
    },
  },
})

export const {setCompletedBatchFilter, resetCompletedBatchFilter} =
  completedBatchFilterSlice.actions

export default completedBatchFilterSlice.reducer
